class ErrorFromString {
	constructor(vueContext, dataError = []) {
		this.error = dataError;
		this.vueContext = vueContext;
	}

	showError = () => {
		let title = this.vueContext.$t("ErrorTitle");
		let text = this.validatorMessage(this.error);

		this.vueContext.$vs.notify({
			color: "danger",
			title,
			text,
			time: 8000,
			icon: "info",
		});
	};

	validatorMessage = (message = "") => {
		if (message.includes("is too short") && !message.includes("[]")) {
			return this.vueContext.$t("Setting.TooShortProperties");
		} else if (message.includes("[] is too short")) {
			return this.vueContext.$t("DesignConfig.SelectMinimumOneOption");
		} else if (message.includes("Exception:")) {
			return this.vueContext.$t("Setting.UnexpectedError");
		} else {
			return this.vueContext.$t("Setting.ValidatorRequiredProperty");
		}
	};
}

export default ErrorFromString;
